import { useTranslation } from 'react-i18next'
import useLanguageStore from './locale'

function useTranslations() {
  const { i18n } = useTranslation()
  const { setLocale } = useLanguageStore()

  const changeLanguage = (newLocale: string) => {
    i18n.changeLanguage(newLocale)
    setLocale(newLocale)
  }

  return {
    changeLanguage,
  }
}

export default useTranslations
